<template>
  <div>
    <!--Vertical Menu-->
    <v-navigation-drawer
      disable-resize-watcher
      class="mobileShow"
      v-model="drawerData"
      :clipped="clipped"
      fixed
      app
    >
      <v-list
        expand
        :style="{ 'align-items': 'center' }"
      >
        <v-list-tile to="/">
          <v-list-tile-title class="font-weight-black.font-italic lt-name-side-title"><b>Logistics</b>Tool</v-list-tile-title>
        </v-list-tile>
        <v-list>
          <v-list-tile
            v-if="thisOperatorIsAdmin"
            to="/Operators/Index"
          >
            <v-list-tile-title>Aggiungi Operatore</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="thisOperatorIsAdmin"
            to="/Procedures/Index"
          >
            <v-list-tile-title>Aggiungi Procedura</v-list-tile-title>
          </v-list-tile>

          <v-list-group
            :value="false"
            no-action
            v-if="thisOperatorIsAdmin"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Mappature</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(map, index) in mappings"
              :key="index"
              @click="navToOperatrosProcedures(map)"
            >
              <v-list-tile-action>
              </v-list-tile-action>
              <!--TODO dinamiche-->
              <v-list-tile-title>{{ map.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            :value="false"
            no-action
            v-if="ProceduresOfUser.length > 0"
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Procedure</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(proc, index) in ProceduresOfUser"
              :key="index"
              @click="navToProcedures(proc.id)"
            >
              <v-list-tile-title> {{ proc.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <!--Horizontal Menu-->
    <v-toolbar
      :clipped-left="clipped"
      fixed
      app
      dark
      color="#43207c"      
    >
      <a
        href="/"
        class="smartLogisticsButton"
      > <b class="stylePaddingHeader">Logistics</b>Tool </a>
      <v-toolbar-side-icon
        class="mobileShow"
        @click="drawerData = !drawerData"
      />
      <v-toolbar-title
        class="headline mr-5"
        v-text="title"
      />
      <v-btn
        v-if="thisOperatorIsAdmin"
        to="/Operators/Index"
        flat
        class="desktopShow lt-button-header-top"
      >Aggiungi Operatore</v-btn>
      <v-btn
        v-if="thisOperatorIsAdmin"
        to="/Procedures/Index"
        flat
        class="desktopShow lt-button-header-top"
      >Aggiungi Procedura</v-btn>

      <v-menu
        offset-y
        :open-on-hover="true"
        v-if="thisOperatorIsAdmin"        
      >
        <v-btn
          class="desktopShow"
          slot="activator"
          color="#43207c"
        >Mappature
        </v-btn>

        <v-list
          class="lt-header-menu-items"
          :nav="true"
          :rounded="true"
        >
          <v-list-tile
            v-for="(map, index) in mappings"
            :key="index"
            @click="navToOperatrosProcedures(map)"
          >
            <v-list-tile-title class="lt-header-menu-item">
              {{ map.title }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-menu
        offset-y
        :open-on-hover="true"
        v-if="ProceduresOfUser.length > 0"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="desktopShow"
            color="#43207c"
            dark
            v-on="on"
          >
            Procedure
          </v-btn>
        </template>
        <v-list
          class="lt-header-menu-items"
          :nav="true"
          :rounded="true"
          style="z-index: 1000"
        >
          <v-list-tile
            v-for="(proc, index) in ProceduresOfUser"
            :key="index"
            @click="navToProcedures(proc.id)"
          >
            <v-list-tile-title class="lt-header-menu-item">
              {{ proc.name }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-spacer />

      <!--User-->
      <!-- <v-menu class="userMenu">
        <v-btn
          icon
          slot="activator"
        >
          <v-icon>person</v-icon>
        </v-btn>
        <v-list class="marginMenu">
          <v-list-tile v-if="$GAUserAuth.user.isAuthenticated">
            <v-list-tile-avatar>
              <v-icon>person</v-icon>
              <span class="white--text headline">{{ userName }}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{
                $GAUserAuth.user.username
                }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>

          <v-list-tile
            v-if="!$GAUserAuth.user.isAuthenticated"
            @click="login"
          >
            <v-list-tile-action>
              <v-icon>fas fa-sign-in-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Login</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-else
            @click="logout"
          >
            <v-list-tile-action>
              <v-icon>fas fa-sign-out-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu> -->
    </v-toolbar>
  </div>
</template>

<script>
import operatorsApi from "../../src/apiLogisticsTool/operatorsApi.js";
import proceduresApi from "../apiLogisticsTool/proceduresApi";

export default {
  props: {
    clipped: Boolean,
    drawer: Boolean,
    fixed: Boolean,
    items: Array,
    title: String,
    userName: String,
    refresh: Boolean
  },

  async created() {
    //await this.$GAUserAuth.refreshUserInfo()
    await this.$GAUserAuth.refreshUserInfo().then(res => {
      // console.log("username refresh: ", this.$GAUserAuth.user);

      const user = this.$GAUserAuth.user.username;

      //prendo le stored procedure assegnate al mio utente
      this.getOperatorsProcedures(user);
      //console.log(this.$GAUserAuth);
      //cerco gli operatori nel mio db e mi faccio ritrornare se sono admin o no
      this.thisOperatorIsAdmin = this.$GAUserAuth.user.gaFunctions.filter(x=>x.Name == "IsAdmin").length > 0;
      // console.log("thisOperatorIsAdmin: ", this.thisOperatorIsAdmin);
      // operatorsApi.IsAdmin(this.$GAUserAuth.user.username).then(response => {
      //   this.thisOperatorIsAdmin = response.data;
      // });

      // usersApi.GetUserOperations(this.$GAUserAuth.user.username).then(response => {
      //   //console.log("operations: ", response.data);
      //   this.operations = response.data;
      //   });

      // usersApi.GetUserExtractions(this.$GAUserAuth.user.username).then(response => {
      //   //console.log("extractions: ", response.data);
      //   this.extractions = response.data;
      //   this.extractionsCategory = [
      //     ...new Set(this.extractions.map(x => x.description))
      //   ] ;
      //   });
    });
  },

  mounted: function() {
    this.drawerData = false;
  },

  data() {
    return {
      stOperatror: false,
      thisOperatorIsAdmin: false,
      drawerData: this.drawer,
      ProceduresOfUser: [],
      operations: [],
      extractions: [],
      extractionsCategory: [],
      //displayHomePagebtn: false
      isUser: false,
      isOperator: false,
      mappings: [{ title: "Operatore-Procedura" }],
      procedures: []
    };
  },

  computed: {},

  methods: {
    updateMenu() {
      const user = this.$GAUserAuth.user.username;
      //prendo le stored procedure assegnate al mio utente
      this.getOperatorsProcedures(user);
    },

    //TODO
    isAdmin() {
      if (this.$GAUserAuth.isAdmin) {
        return true;
      } else {
      }
    },

    getOperatorsProcedures(user) {
      proceduresApi.GetProceduresByUserName(user).then(response => {
        this.ProceduresOfUser = response.data;
      });
    },

    // updateMenu() {
    //   //console.log("update menu ");
    //   this.getUserOperations();
    //   this.getUserExtractions();
    // },
    // getUserOperations() {
    //   usersApi.GetUserOperations(this.$GAUserAuth.user.username).then(response => {
    //     //console.log("operations: ", response.data);
    //     this.operations = response.data;
    //     });

    // },
    // getUserExtractions() {
    //   usersApi.GetUserExtractions(this.$GAUserAuth.user.username).then(response => {
    //     //console.log("extractions: ", response.data);
    //     this.extractions = response.data;
    //     this.extractionsCategory = [
    //       ...new Set(this.extractions.map(x => x.description))
    //     ] ;
    //     });
    // },

    filterExtractions(ec) {
      var filteredExtractions = this.extractions.filter(function(el) {
        return el.description == ec;
      });
      return filteredExtractions;
    },
    // navToOperation: function(e) {
    //   this.navigateTo(e.controller);
    // },
    // navToExtraction: function(e) {
    //   //console.log("menu e ", e);
    //   this.navigateTo("/Extractions/View/"+e.id);
    // },
    navigateTo: function(a) {
      location.href = a;
    },
    navToProcedures(id) {
      this.navigateTo("/Procedures/View/" + id);
    },
    navToOperatrosProcedures() {
      this.navigateTo("/OperatorsProcedures/Index");
    },
    async login() {
      await this.$GAUserAuth.signin();
    },
    async logout() {
      await this.$GAUserAuth.signout();
    }
  }
};
</script>

<style>
.lt-name-side-title {
  color: #5c6366 !important;
  font-size: 20px;
}
/* 
.lt-header-menu-items {
  position: relative;
  padding: 10px;
  text-align: left;
  line-height: 30px;
  font-size: 16px;
}

.lt-header-menu-item{
  position: relative;
  padding: 5px;
  display: block;
  line-height: 30px;
  font-size: 16px;
} */

/* .lt-header-menu-item:hover{
  cursor: pointer;
  background-color: rgba(92, 99, 102, 0.2) 
} */

.lt-button-header-top {
  padding-top: 8px;
}

hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.userMenu {
  position: absolute;
  right: 24px;
}

.font-weight-bold {
  color: white !important;
}

.font-weight-thin.font-italic {
  color: white !important;
}

.highlighted {
  color: lightgray !important;
}
.mobileShow {
  display: none !important;
}
.desktopShow {
  display: block;
  box-shadow: none !important;
}
.marginMenu {
  margin-top: 5vh;
}
@media (max-width: 1000px) {
  .mobileShow {
    display: block !important;
  }
  .desktopShow {
    display: none !important;
  }
}
.subMenu {
  position: absolute;
  left: 120px;
  top: 0px;
}
.v-menu__content {
  contain: initial !important;
  overflow-y: initial;
  overflow-x: initial;
}
.mnuBtn {
  background-color: rgba(0, 0, 0, 0) !important;
  color: white;
  box-shadow: rgba(255, 255, 255, 0) 0px 0px 0pt !important;
  display: table;
  font-family: unset !important;
  padding: 1 !important;
  user-select: none;
  cursor: default;
  margin-bottom: 1px;

  border-radius: 0 !important;
}
.menu {
  background-color: #5c6366 !important;
  color: white !important;
  border-radius: 0 !important;
}
.mnuLst {
  border-radius: 0 !important;
  background-color: #5c6366 !important;
}
.v-toolbar__content {
  height: 48px !important;
}
</style>
